import { createContext } from 'react';

/**
 * We use this context to help manage when the application is on preview mode
 */
export const PreviewModeDataContext = createContext({
  data: null,
  isPreview: false
});

export { default as usePreviewModeDataContext } from '../../hooks/usePreviewModeDataContext';
export { default as PreviewModeDataContextProvider } from './PreviewModeDataContextProvider';
